export default __webpack_public_path__ + "static/media/report_preview_img@2x.ff12b7b0.png";